import { Helmet } from "react-helmet-async";
import { KNAPPLogo } from "./Icons";
import ResumeButton from "./ResumeButton";

function About() {
  return (
    <div className="min-h-[calc(100vh-160px)] flex flex-col justify-start px-6 py-6 text-center bg-gradient-to-br from-gray-900 via-gray-800 to-gray-700">
      <Helmet>
        <title>About Me | Luis Torre</title>
        <meta name="description" content="Learn more about Luis Torre, a Computer Engineering graduate working in automation." />
      </Helmet>

      <h2 className="text-4xl font-bold text-white mb-4 relative inline-block mx-auto">
        About Me
        <span className="absolute left-0 bottom-0 w-full h-1 bg-[#45577a] rounded-full"></span>
      </h2>

      <ResumeButton />

      <div className="max-w-[1300px] xl:max-w-[1500px] mx-auto w-full text-center">
        {/* Text + Logo Section */}
        <div className="w-full grid grid-cols-1 lg:grid-cols-[4fr_2fr] items-center gap-10 px-4 lg:px-8">
          <p className="text-gray-300 text-lg leading-relaxed mt-4 text-center">
            Hello! I’m a Computer Engineering graduate from the University of Florida, 
            and I currently work at KNAPP as a Logistics Operations Engineer. I’m really 
            into Automation, building smart solutions, and AI—I love taking on challenging 
            problems and turning ideas into real projects, whether it’s embedded systems or full-stack web apps.
          </p>

          <div className="flex justify-center">
            <KNAPPLogo width={350} height={130} className="mx-auto" />
          </div>
        </div>

        {/* Divider */}
        <div className="h-[2px] w-32 bg-gray-400 my-8 mx-auto rounded-full"></div>

        {/* Paragraph sections */}
        <div className="max-w-3xl mx-auto space-y-8 text-gray-300 text-lg leading-relaxed">
          <p>
            When I’m not tinkering with tech, you’ll probably find me in the kitchen—I love cooking and actually worked as a cook in a restaurant, which taught me a lot about teamwork and working under pressure. I’m also a bit of a language nerd: I speak English and Spanish, and I’m diving into German right now.
          </p>
          <div className="h-[2px] w-32 bg-gray-400 mx-auto rounded-full"></div>
          <p>
            Outside of work and tech, I’m really into fitness and health—I enjoy weightlifting, running, and hiking. I also love traveling and exploring new cultures; it’s one of my favorite ways to learn and grow.
            I like combining my technical skills with my personal passions, always looking for ways to learn, create, and make things a little smarter and more fun.
          </p>
        </div>
      </div>
    </div>
  );
}

export default About;
